import { CrfField, CrfReading } from "../nebula.service";

/**
 * Checks if any fields in the provided readings have conflicting values
 * @param readings - Array of readings to check for conflicts
 * @param fields - Array of field definitions
 * @returns boolean - True if any fields have conflicts, false otherwise
 */
export const hasAnyConflicts = (readings: CrfReading[], fields: CrfField[]): boolean => {
    for (const field of fields) {
        const values = new Set();
        for (const reading of readings) {
            const fieldValue = reading.values.find((val) => val.fieldName === field.fieldName)?.fieldValue;
            if (fieldValue !== undefined) {
                // Convert to string to ensure consistent comparison (handles number vs string cases)
                values.add(String(fieldValue));
            }
        }
        if (values.size > 1) {
            return true;
        }
    }
    return false;
};
